export default {
    API_ENDPOINT: 'https://sleepy-coast-68561.herokuapp.com/api',
    API_KEY: process.env.REACT_APP_API_TOKEN,
  }